function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#231F20",
  strokeLinecap: "round",
  strokeWidth: 2,
  transform: "translate(3 2)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M10.9984,8.6585 C10.9984,10.3155 9.6554,11.6585 7.9984,11.6585 C6.3414,11.6585 4.9984,10.3155 4.9984,8.6585 C4.9984,7.0015 6.3414,5.6585 7.9984,5.6585 C9.6554,5.6585 10.9984,7.0015 10.9984,8.6585 Z"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M6.9984.0003C9.3284.8233 10.9984 3.0463 10.9984 5.6583L10.9984 8.6583M.0004 5.1946C1.8784 3.5896 4.6384 3.2546 6.9004 4.5606L9.4984 6.0606M.9994 13.8538C.5484 11.4238 1.6384 8.8668 3.9004 7.5608L6.4984 6.0608M8.9984 17.3167C6.6684 16.4937 4.9984 14.2707 4.9984 11.6587L4.9984 8.6587M15.9965 12.1223C14.1185 13.7273 11.3585 14.0623 9.0965 12.7563L6.4985 11.2563M14.9974 3.4632C15.4484 5.8932 14.3584 8.4502 12.0964 9.7562L9.4984 11.2562"
}));

var SvgPortals = function SvgPortals(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 22,
      height: 22,
      viewBox: "0 0 22 22"
    }, props), _ref)
  );
};

export default SvgPortals;